import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { updateOrdersAction } from "../../MyApi/orders";

const RefundModal = ({ isOpen, toggle, orderId, onSuccess, orderItems ,orderData ,isMultiStore ,refetchOrder }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const [reason, setReason] = useState("Item arrived damaged");
  const getOrderIdForSelectedItem = () => {
  if (!selectedItem) return null; // fallback to parent

  // Multi-store: find the child order that contains the selected item
  if (orderData.data?.order.children?.length > 0) {
    for (const childOrder of orderData.data.order.children) {
      const foundItem = childOrder.items.find(item => item.id === selectedItem.id);
      if (foundItem) {
        return childOrder.id; // send the child order ID
      }
    }
  }

  // Single-store: use main order ID
  return orderId;
};
  // Mutation for refund
  const mutation = useMutation(
    (refundData) => updateOrdersAction(refundData, getOrderIdForSelectedItem()),
    {
      onSuccess: () => {
        toast.success("تم استرداد المنتج بنجاح");
        onSuccess();
        toggle();
        refetchOrder()
      },
      onError: () => {
        toast.error("فشل في استرداد المنتج");
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedItem) {
      toast.error("الرجاء اختيار عنصر واحد");
      return;
    }

    if (selectedQuantity <= 0) {
      toast.error("الرجاء اختيار كمية أكبر من 0");
      return;
    }

    // Calculate refund amount based on selected quantity
    const refundAmount = (selectedQuantity * (selectedItem.total_price / selectedItem.quantity)) / selectedItem.currency_factor;

    // Prepare payload for the selected item with custom quantity
    const payload = {
      action_type: "refund_item",
      order_item_id: selectedItem.id,
      amount: refundAmount,
      order_item_quantity: selectedQuantity,
      reason,
    };

    mutation.mutate(payload);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>استرداد منتج</ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          {orderItems.map((item) => (
            <div
              key={item.id}
              className="d-flex align-items-center justify-content-between border-bottom py-2"
            >
              <div className="d-flex align-items-center gap-3">
                <input
                  type="radio"
                  name="selectedItem"
                  onChange={() => {
                    setSelectedItem(item);
                    setSelectedQuantity(item.quantity);
                  }}
                  checked={selectedItem?.id === item.id}
                  disabled={item.action_status === "refunded" || item.action_status === "replaced"}
                />

                <img
                  src={item.product?.image}
                  width="45"
                  height="45"
                  style={{ objectFit: "cover", borderRadius: "6px" }}
                  alt={item.product?.name}
                />

                <div>
                  <div className={`fw-bold ${item.action_status === "refunded" ? "text-danger " : item.action_status === "replaced" ? "text-success" : "text-dark"}`}>
                    {item.product?.name} ({item.action_status === "refunded" ? "تم استرداده" : item.action_status === "replaced" ? "تم استبداله" : "قيد المعالجة"})
                  </div>
                  <div className="small text-muted">الكمية المتاحة: {item.quantity}</div>
                </div>
              </div>

              <div className="d-flex flex-column align-items-end">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <label className="form-label mb-0 small">الكمية:</label>
                  <input
                    type="number"
                    min="0"
                    max={item.quantity}
                    value={selectedItem?.id === item.id ? selectedQuantity : 0}
                    onChange={(e) => {
                      const qty = parseInt(e.target.value) || 0;
                      if (qty >= 0 && qty <= item.quantity) {
                        setSelectedQuantity(qty);
                      }
                    }}
                    disabled={selectedItem?.id !== item.id || item.action_status === "refunded" || item.action_status === "replaced"}
                    className="form-control form-control-sm"
                    style={{ width: "100px" }}
                  />
                </div>
                
                <div className="fw-bold text-danger">
                  {(selectedItem?.id === item.id ? (selectedQuantity * (item.total_price / item.currency_factor)) : 0).toLocaleString()} {item.symbol_currency}
                </div>
              </div>
            </div>
          ))}

          <div className="row mt-3">
            <div className="col-12 mb-3">
              <label className="form-label">السبب</label>
              <textarea
                className="form-control"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows="3"
                required
              />
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button
              type="button"
              className="btn btn-white"
              onClick={toggle}
              disabled={mutation.isLoading}
            >
              إلغاء
            </button>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={mutation.isLoading}
            >
              {mutation.isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  جاري المعالجة...
                </>
              ) : (
                "إرسال طلب الاسترداد"
              )}
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default RefundModal;